import React, { useCallback, useContext, useLayoutEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import { _T } from 'appI18n';
import { BackdropContext } from 'react-components/BackdropProvider';
import { GlobalSpinnerContext } from 'react-components/GlobalSpinnerProvider';
import { toURLSearchParams } from 'utils';
import { useTourSearchStore } from '../../store/TourSearchStore';
import NoSearchResults from '../NoSearchResults';
import { TourSearchResultCard, TourSearchResultCardSkeleton } from '../TourSearchResultCard';
import TourSearchResultsHeader from './TourSearchResultsHeader';
import { ReplaceCartTourDialog } from '../../../NewTourSearch/compoments/TourSearch';
function TourSearchResultItem({ item, actions, forceDocumentNavigation = false }) {
    const { pathname, search: searchStr, state: historyState } = useLocation();
    const backdrop = useContext(BackdropContext);
    //const handlePurchase = useCallback((tourVariant: TourVariantWithAccommodations, accmdVariant: TourAccomodationVariant[] | undefined, hash: string, replaceExistingTour: boolean, onError: (errors: string[]) => void) => {
    const handlePurchase = useCallback((tourVariant, accmdVariant, hash) => {
        backdrop.show();
        //actions.book(tourVariant.id, accmdVariant ? accmdVariant.map((x) => x.id) : [], hash, replaceExistingTour, {
        actions.book(tourVariant.id, accmdVariant ? accmdVariant.map((x) => x.id) : [], hash, false, {
            onError: (errors) => {
                if (errors.includes("CART_CONFLICT_SERVICE") || errors.includes("CART_CONFLICT_CURRENCY")) {
                    const reason = errors.includes("CART_CONFLICT_CURRENCY") ? "currency" : "service";
                    const showModal = window.showCartConflictModal;
                    if (showModal) {
                        showModal({
                            reason,
                            onReplace: () => actions.book(tourVariant.id, accmdVariant ? accmdVariant.map((x) => x.id) : [], hash, false, {
                                replaceCart: true,
                                onError: () => backdrop.hide(),
                            }),
                        });
                        backdrop.hide();
                        return;
                    }
                }
                if (errors.length && errors[0] == "CART_ALREADY_CONTAINS_OTHER_TOUR")
                    setReplaceCartTourDialogPrice({ tourVariant, accmdVariant, hash });
                //onError(errors);
                backdrop.hide();
            }
        });
    }, [actions, backdrop, item]);
    const genUrl = useCallback((variantId, accmmdId, hash) => {
        return actions.genTourDetailsUrl(variantId, accmmdId, item.name, hash, encodeURIComponent(pathname + searchStr));
    }, [actions.genTourDetailsUrl, item.name, pathname, searchStr]);
    const [replaceCartTourDialogPrice, setReplaceCartTourDialogPrice] = useState();
    return (React.createElement(React.Fragment, null,
        React.createElement(TourSearchResultCard, { key: item.id, item: item, book: handlePurchase, genUrl: genUrl, forceDocumentNavigation: forceDocumentNavigation }),
        replaceCartTourDialogPrice
            ? React.createElement(ReplaceCartTourDialog, { price: replaceCartTourDialogPrice, open: !!replaceCartTourDialogPrice, onClose: () => setReplaceCartTourDialogPrice(undefined), onCancel: () => setReplaceCartTourDialogPrice(undefined), onApprove: p => {
                    actions.book(p.tourVariant.id, p.accmdVariant ? p.accmdVariant.map((x) => x.id) : [], p.hash, true, {
                        onError: (errors) => {
                            //onError(errors);
                            backdrop.hide();
                        },
                        onSuccess: () => setTimeout(() => setReplaceCartTourDialogPrice(undefined), 200),
                    });
                } }) : null));
}
function TourSearchResultList(props) {
    return React.createElement(React.Fragment, null, props.items && props.items.length > 0
        ? props.items.map(item => React.createElement(TourSearchResultItem, { key: item.id, item: item, actions: props.actions, forceDocumentNavigation: props.forceDocumentNavigation }))
        : React.createElement(NoSearchResults, null));
}
function TourSearchResults({ hideHeader = false, forceDocumentNavigation = false, suppressInitialSpinner = false, hideWhileLoading = false, onSearchResultReady }) {
    const [{ loading, searchQuery, searchResult, page, pageCount, errors }, actions] = useTourSearchStore();
    const { pathname } = useLocation();
    const scrollAnchorRef = React.createRef();
    const lastReadySearchResult = useRef();
    const lastReadyErrors = useRef();
    const spinner = useContext(GlobalSpinnerContext);
    // DISPLAY BOOKING ERRORS BRUH
    //const [isBookingErrorVisible, setBookingErrorVisible] = useState(false);
    const renderPaginationItem = (item) => {
        const url = `${pathname}?${toURLSearchParams(Object.assign(Object.assign({}, searchQuery), { page: item.page - 1 })).toString()}`;
        return React.createElement(PaginationItem, Object.assign({ component: Link, to: url }, item));
    };
    const havePagination = pageCount > 1;
    const pagination = (onChange) => !havePagination ? React.createElement("div", null) : (React.createElement(Pagination, { renderItem: renderPaginationItem, count: pageCount, page: page + 1, color: "secondary", disabled: loading, onChange: onChange }));
    // Отображение спиннера при первой загрузке если результаты поиска еще не доступны.
    useLayoutEffect(() => {
        if (!suppressInitialSpinner && !searchResult && loading)
            spinner.show();
        else
            spinner.hide();
    }, [suppressInitialSpinner, searchResult, loading]);
    useLayoutEffect(() => {
        if (!onSearchResultReady || loading)
            return;
        if (searchResult && lastReadySearchResult.current !== searchResult) {
            lastReadySearchResult.current = searchResult;
            setTimeout(() => onSearchResultReady(), 500);
            return;
        }
        if ((errors === null || errors === void 0 ? void 0 : errors.length) && lastReadyErrors.current !== errors) {
            lastReadyErrors.current = errors;
            setTimeout(() => onSearchResultReady(), 500);
        }
    }, [onSearchResultReady, searchResult, errors, loading]);
    if (!searchResult && (errors === null || errors === void 0 ? void 0 : errors.length)) {
        return (React.createElement(Box, { mb: 2 },
            React.createElement(Alert, { severity: "error" },
                React.createElement(AlertTitle, null, _T.COMMON_ERROR),
                errors.length > 1 ? React.createElement("ul", null, errors.map(x => React.createElement("li", null, x))) : errors[0])));
    }
    if (!searchResult || (hideWhileLoading && loading))
        return React.createElement("div", null);
    return (React.createElement("div", { ref: scrollAnchorRef },
        searchResult && searchQuery && !hideHeader
            ? React.createElement(TourSearchResultsHeader, { searchQuery: searchQuery, searchResult: searchResult })
            : null,
        (errors === null || errors === void 0 ? void 0 : errors.length) ?
            (React.createElement(Box, { mb: 2 },
                React.createElement(Alert, { severity: "error" },
                    React.createElement(AlertTitle, null, _T.COMMON_ERROR),
                    errors.length > 1 ? React.createElement("ul", null, errors.map(x => React.createElement("li", null, x))) : errors[0]))) : null,
        (searchResult === null || searchResult === void 0 ? void 0 : searchResult.tours.length) && React.createElement(Box, { mb: 2, display: "flex", justifyContent: "flex-start" }, pagination()) || null,
        !loading && searchResult
            ? React.createElement(TourSearchResultList, { items: searchResult.tours, actions: actions, forceDocumentNavigation: forceDocumentNavigation })
            : loading ? Array(10).fill(0).map((_, i) => React.createElement(TourSearchResultCardSkeleton, { key: i }))
                : null,
        havePagination &&
            React.createElement(Box, { my: 2, display: "flex", justifyContent: "flex-end" }, pagination(withScrollTop(scrollAnchorRef))) || null));
}
const withScrollTop = (ref) => (next) => (e, page) => {
    var _a;
    next && next(e, page);
    // Скролл в начало страницы.
    try {
        const rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        // XXX: "на глазок" определил нужный оффсет скролла (чтоб заголовки было видно).
        window.scrollTo({ top: rect.y + window.scrollY - 200, behavior: "smooth" });
    }
    catch (_b) {
        console.warn("Couldn't smooth-scroll to top. Using fallback.");
        window.scrollTo(0, 0);
    }
};
export default TourSearchResults;
